// -1 = Não cadastrado
//  0 = Generico
//  1 = Region
//  2 = Planta Hidreletrica
//  3 = Bay
//  4 = Unidade Geradora
//  5 = Máquina Sincrona
//  6 = Mancal
//  7 = Turbina Hidro
//  8 = Planta Wind
//  9 = Wind Farm
//  10 = Turbina Eólica
//  11 = Sensor
//  999 = Empresa
//  1000 = Home
//  1001 = Configurações
const Undefined = -1;
const Generic = 0;
const Region = 1;
const HydroElectricPowerPlant = 2;
const Bay = 3;
const HydroElectricGeneratingUnit = 4;
const SynchronousMachines = 5;
const Bearings = 6;
const HydroTurbine = 7;
const WindComplex = 8;
const WindPowerPlant = 9;
const WindTurbine = 10;
const Sensor = 11;
// Não usar as variaveis abaixo, porque são utilizados essas numerações no front-end para formar a treeview.
const Company = 999;
const Home = 1000;
const Settings = 1001;
const Notifications = 1002;

export default {
	Undefined,
	Generic,
	Region,
	HydroElectricPowerPlant,
	Bay,
	HydroElectricGeneratingUnit,
	SynchronousMachines,
	Bearings,
	HydroTurbine,
	WindComplex,
	WindPowerPlant,
	WindTurbine,
	Sensor,
	Company,
	Home,
	Settings,
	Notifications
};
